import React, { createElement } from 'react';

export interface TabPanelProps {
    panelId: string;
    style: object;
    children?: any;
}


const TabPanel: React.FC<TabPanelProps> = (props) => {
    const { panelId, style, children } = props;

    return (
        <div id={panelId} style={style}>
            {children}
        </div>
    );
};

export default TabPanel;
